<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>d</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.question.mcq') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <h1>{{ $t('pages.questions.MCQModification.title.name') }}</h1>

      <m-c-q-form :is-modification="true"
                   @save="save"
      />
    </section>
  </div>
</template>

<script>
import MCQForm from '@/components/questions/formMCQ.vue'
import { mapActions } from 'vuex'

export default {
  name: 'questionMcqModification',
  components: {
    MCQForm
  },
  methods: {
    ...mapActions('Questions', [
      'saveQuestion'
    ]),
    async save (payload) {
      await this.saveQuestion(
        {
          question: payload.question,
          redirect: payload.saveType === 'save'
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
</style>
